module.exports = __webpack_public_path__ + "static/img/kefu.9f282d85.png";